// src/pages/Contact/Contact.jsx
import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { FaLeaf } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

import Button from "../../../components/general/button/Button.js";
import ContactForm from "../../../subscreens/customer/contactus/Contactform.js";
import ContactMapSocial from "../../../subscreens/customer/contactus/ContactMapSocial.js";
import ContactInfo from "../../../subscreens/customer/contactus/Contactinfo.js";

import MyNavbar from "../../../components/general/navbar/MyNavbar";
import PageHero from "../../../components/general/pageHero/PageHero";
import Footer from "../../../components/general/footer/Footer.js";
import "../../../assets/css/customer/contact/Contact.css";

const Contact = () => {
  const navigate = useNavigate();

  return (
    <div className="contact-page">
      <MyNavbar />

      <PageHero title="Contact Us" breadcrumb="contact" />

      {/* HERO SECTION */}
      <section className="contact-hero">
        <Container>
          <Row className="justify-content-center mt-4">
            <Col xs={12}>
              <ContactInfo />
            </Col>
          </Row>
        </Container>
      </section>

      {/* FORM SECTION */}
      <section className="contact-form-section">
        <Container>
          <Row className="g-5">
            <Col xs={12} lg={6}>
              <ContactForm />
            </Col>

            <Col xs={12} lg={6}>
              <ContactMapSocial />
            </Col>
          </Row>
        </Container>
      </section>

      {/* CTA SECTION (FIXED - ALWAYS SHOWS) */}
      <section className="contact-cta">
        <Container>
          <Row className="justify-content-center text-center">
            <Col xs={12} lg={8}>
              <div className="cta-content animate-in">
                <h2 className="cta-title">Ready to Start Shopping?</h2>

                <p className="cta-description">
                  Browse our fresh collection of organic products
                </p>

                <div className="cta-buttons">
                  <Button
                    variant="gradient"
                    icon={<FaLeaf />}
                    onClick={() => navigate("/products")}
                  >
                    Shop Now
                  </Button>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <Footer />
    </div>
  );
};

export default Contact;
